import React from "react";
import Button from "../../ui/Button";
import EntryContent from "../../ui/EntryContent";
import SectionCardDark from "../../ui/SectionCardDark";
import SiteLink from "../../ui/SiteLink";

import Loadable from "@loadable/component";

const ReactPlayerLazy = Loadable(() => import("react-player"));

const VirtualMachine = ({ data }) => {
  const { title, description, cta, list, video } = data;
  return (
    <SectionCardDark>
      <div className="mb-section grid gap-8 lg:grid-cols-2">
        <EntryContent inverted className="max-w-md prose-headings:text-h2">
          <h3>{title}</h3>
        </EntryContent>
        <div className="grid gap-8">
          <EntryContent inverted>
            <p>{description[0].children[0].text}</p>
          </EntryContent>
          <p className="text-background">
            <Button asChild variant={"link-invert"} size={"link"}>
              <SiteLink
                to={cta.link}
                external={cta.isExternal}
                iconExternal={cta.isExternal}
              >
                {cta.label}
              </SiteLink>
            </Button>
          </p>
        </div>
      </div>
      <div className="-mx-section aspect-video">
        <ReactPlayerLazy
          url={video.asset.url}
          loop
          muted
          playing
          width="100%"
          height="100%"
        />
      </div>
      <div className="mt-section grid gap-6">
        <div className="grid gap-6 sm:grid-cols-6">
          {list._rawItems.map(
            ({ _id, title, description, image }, index: number) => (
              <SectionCardDark.CardInner
                key={_id}
                className={
                  index > 1
                    ? "sm:col-span-3 lg:col-span-2"
                    : "sm:col-span-3 lg:col-span-3"
                }
              >
                <div className="mb-2 flex h-12 w-12 items-center justify-center">
                  <img src={image.asset.url} alt={title} />
                </div>
                <EntryContent
                  inverted
                  className="prose-headings:mb-2 prose-headings:text-lg"
                >
                  <h3>{title}</h3>
                  <p>{description[0].children[0].text}</p>
                </EntryContent>
              </SectionCardDark.CardInner>
            )
          )}
        </div>
      </div>
    </SectionCardDark>
  );
};

export default VirtualMachine;
